import React from 'react';
import { Button, Space } from 'antd';

/**
 * Reusable table header actions component
 * Shows custom actions when rows are selected
 */
const TableHeaderActions = ({ 
  selectedCount, 
  totalCount, 
  actions = [],
  onClearSelection 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-blue-700 font-medium">
            {selectedCount} of {totalCount} row(s) selected
          </span>
        </div>
        
        <Space>
          {actions.map((action, index) => (
            <Button
              key={index}
              type={action.type || 'default'}
              size="small"
              icon={action.icon}
              onClick={action.onClick}
              loading={action.loading}
              disabled={action.disabled}
              className={action.className}
            >
              {action.label}
            </Button>
          ))}
          
          <Button 
            size="small" 
            onClick={onClearSelection}
            className="text-gray-500"
          >
            Clear Selection
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default TableHeaderActions;
